import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TasksChecklist.css';
import CheckBox from '../../../shared/checkbox/CheckBox';

const values = {
  arrived_onsite: {
    id: 'arrived_onsite',
    labelForContractor: 'I have arrived onsite.',
    labelForRest: 'Contractor has arrived onsite.',
    order: 1,
  },
  checked_security: {
    id: 'checked_security',
    labelForContractor: 'I have checked with security.',
    labelForRest: 'Contractor has checked with security.',
    order: 2,
  },
  checked_in: {
    id: 'checked_in',
    labelForContractor:
      'I have made contact/checked in with the client/contact person.',
    labelForRest:
      'Contractor has made contact/checked in with the client/contact person.',
    order: 3,
  },
  verified_work: {
    id: 'verified_work',
    labelForContractor: 'I have verified I can complete work.',
    labelForRest: 'Contractor has verified it can complete work.',
    order: 4,
  },
  protected_work: {
    id: 'protected_work',
    labelForContractor: 'I have protected work that is to remain.',
    labelForRest: 'Contractor has protected work that is to remain.',
    order: 5,
  },
};

class TasksChecklist extends Component {
  static propTypes = {
    readOnly: PropTypes.bool.isRequired,
    selectedStatus: PropTypes.arrayOf(
      PropTypes.oneOf(Object.keys(values).concat(null))
    ),
    showForContractor: PropTypes.bool.isRequired,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    selectedStatus: [],
  };

  render() {
    return (
      <div className="tasks-checklist">
        {Object.entries(values).map((entry) => {
          const found = this.props.selectedStatus.find(
            (status) => status === entry[1].id
          );

          if (found === undefined) {
            return this.renderItem(
              entry[1].order,
              entry[1].id,
              this.props.showForContractor
                ? entry[1].labelForContractor
                : entry[1].labelForRest,
              this.props.readOnly,
              false
            );
          } else {
            return this.renderItem(
              entry[1].order,
              entry[1].id,
              this.props.showForContractor
                ? entry[1].labelForContractor
                : entry[1].labelForRest,
              this.props.readOnly,
              true
            );
          }
        })}
      </div>
    );
  }

  handleChange = (id) => {
    if (this.props.onSelect !== undefined) {
      this.props.onSelect(id);
    }
  };

  renderItem(key, id, label, readOnly, checked) {
    return (
      <div key={key} className="tasks-checklist-item">
        <CheckBox
          id={id}
          readOnly={readOnly}
          checked={checked}
          size="medium"
          shape="square"
          onChange={this.handleChange}
        />
        <span>{label}</span>
      </div>
    );
  }

  static keys = Object.keys(values);
}

export default TasksChecklist;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/TasksChecklist.js